import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../utils/storeApp";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import CallAPI from "../../services/apiCalls";
import DetailsOrgEmails from "./DetailsOrgEmails";
import UserEmailList from "../users/UserEmailList";
import { Dropdown } from 'primereact/dropdown'; 

let o = {
  OrganizationId: "",
  Email: "",
  SearchBy: "",
  FromDate: "",
  ToDate: "",
  UserName: "",
  Name: "",
};

const ListEmails = () => {
  const {
    userRole,
    userToken,
    SetSharedObject,
    sharedObject,
    XdrArr,
    setXDRArr,
    userSession,
  } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
    sharedObject: state.sharedObject,
    XdrArr: state.XdrArr,
    setXDRArr: state.setXDRArr,
    userSession: state.userSession,
  }));
  const [userObj, setUserObj] = useState([]);
  const [emailListObj, setEmailListObj] = useState([]);
  const [showGridFlag, SetShowGridFlag] = useState(false);
  const [showEmptyGridFlag, SetShowEmptyGridFlag] = useState(
    userRole === "SESADMIN" ? true : false
  );
  const navigate = useNavigate();
  const [addBtnFlag, setAddBtnFlag] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [customerCustVal, setCustomerCustVal] = useState(null);
  const [orgObj, SetOrgObj] = useState([]);
  const [customerOrgVal, setCustomerOrgVal] = useState(null);
  const [customerObj, SetCustomerObj] = useState([]);
  const [customerCustValSearch, setCustomerCustValSearch] = useState(null);
  const [orgObjSearch, SetOrgObjSearch] = useState([]);
  const [customerOrgValSearch, setCustomerOrgValSearch] = useState(false);
  const [customerObjSearch, SetCustomerObjSearch] = useState([]);
  const [answers, setAnswers] = useState(o);
  const [detailsEmail, setdetailsEmail] = useState({});
  const [modelEmailObj, setModelEmailObj] = useState({});
  const [showBackBtn, SetShowBackBtn] = useState(false);
  const [custFlag, SetCustFlag] = useState(false);
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [cmfMessage, SetCmfMessage] = useState(
    "Are you sure you want to delete email(s)?"
  );
  const [cmfFlag, SetCmfFlag] = useState(false);
  const [cmfFlagDisplay, SetCmfFlagDisplay] = useState(false);
  const [reasonInput, setReasonInput] = useState("");
  const [submitFlag, setSubmitFlag] = useState(false);
  const [sbmitFlag, setSbmitFlag] = useState(false);
  const [searchEmail, setSearchEmail] = useState("");
  const [orgId, setOrgId] = useState(false);
  const [processingDelete, setprocessingDelete] = useState(false);
    const [deleteFlag, setDeleteFlag] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
  const setAnswer = (questionId, answer) => {
    setAnswers({ ...answers, [questionId]: answer });
  };

  const getXDREndPoints = async () => {
    setProcessing(true);
    SetErrDetailFlag(false);
    let call = "/organization/getAllXDREndPoints";
    const res = await CallAPI(call, false, "get", userToken);
    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setXDRArr(res.data.data);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const getOrgIdEmailsList = async (mdl) => {
    setProcessing(true);
    SetErrDetailFlag(false);
    let call = "";
    if (mdl.Flag === "orgEmails") {
      call = "/organization/GetDirectEmails?orgId=" + mdl.Id;
    } else {
      call = "/emails/GetUsersDirectEmails?userId=" + mdl.Id;
    }
    const res = await CallAPI(call, false, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      setProcessing(false);
      setAddBtnFlag(true);
      let tempObj = [];
      for (const row of res.data.data) {
        row.CustomerId = customerCustVal;
        row.FlagType = "emailLIst";
        row.organizationId = mdl.Id;

        if (mdl.Flag === "orgEmails") {
          row.id = row.directEmailId;
          row.emailType = "orgEmails";
          row.userId = 0;
        } else {
          row.emailType = "userEmails";
        }

        let cs = (
          <a
            href="javascript:void(0);"
            underline="none"
            className="font-weight-bold"
            onClick={() => {
              emailType(row, "show");
            }}
          >
            {row.directEmailAddress}
          </a>
        );
        row.dtCreated = new Date(row.dateCreated);
        row.date = new Date(row.dateCreated);
        row.GridLinkCourse = cs;
        row.keepMdn = row.keepMDN ? "YES" : "NO";
        row.directEmailPurpose =
          row.directEmailPurposeId === 0 || row.emailPurposeId === 0
            ? "General"
            : row.directEmailPurposeId === 1 || row.emailPurposeId === 1
            ? "Medical RecordsXML only"
            : row.directEmailPurposeId === 2 || row.emailPurposeId === 2
            ? "Medical Records"
            : "Administrative";
        let es = (
          <a
            href="javascript:void(0);"
            underline="none"
            className="font-weight-bold"
            onClick={() => {
              emailTypeName(row, "show");
            }}
          >
            {row.name}
          </a>
        );
        row.EmailDirect = es;
        row.name = mdl.Name;

        if (row.userEmailTypeString !== "Shared") {
          tempObj.push(row);
        }
      }

      if (tempObj.length > 0) {
        $("#advEmailSearchModal").modal("hide");
      }

      SetSharedObject("emailListObj", tempObj);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  useEffect(() => {
    setAddBtnFlag(false);
    SetSharedObject("emailsSharing", []);
    SetCustomerObj(sharedObject.vendorsObj);

    const temp = [];
    if (sharedObject?.vendorsObj?.length > 0) {
      for (let el of sharedObject.vendorsObj) {
        el.show = true;
        temp.push(el);
      }
    }

    SetCustomerObjSearch(temp);
    let obj = sharedObject.UserIdEmail;

    if (Object.keys(obj).length > 0 && obj.constructor === Object) {
      setAddBtnFlag(true);
      SetShowGridFlag(true);
      SetCustFlag(true);
      getOrgIdEmailsList(obj);
    }

    if (userRole !== "SES ADMINISTRATOR") {
      OrgSearchEngine(userSession.vendor_id);
      SetSharedObject("reloadEmailList", false);
    }

    getXDREndPoints();
  }, [sharedObject.reloadEmailList]);

  const OrgSearchEngine = async (id) => {
    let obj = { VendorId: id };
    setProcessing(true);

    let call = "/organization/OrgSearchEngine";
    const res = await CallAPI(call, obj, "post", userToken);
    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      let dt = res.data.data;
      const temp = [];
      for (let el of dt) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObjSearch(temp);
      SetOrgObj(temp);
      setProcessing(false);
    }
  };

  const GetXdrConfig = async (vl) => {
    let tempXDR = {};
    if (vl) {
      for (let el of XdrArr) {
        if (el.id === parseInt(vl)) {
          tempXDR = el;
          break;
        }
      }
    }

    SetSharedObject("orgXDRObj", tempXDR);
    SetSharedObject("xdrSettiingObj", tempXDR);
  };

  const getEmailsList = async (mdl, check, userEmails) => {
    setProcessing(true);
    SetErrDetailFlag(false);
    if (check) {
      await getOrgDetails(mdl.OrganizationId);
    }

    let call = "";
    let obj = null;

    if (userEmails) {
      call = "/emails/GetUserEmails?SesUserId=" + parseInt(mdl.UserId);
      obj = false;
    } else {
      setModelEmailObj(mdl);
      obj = mdl;
      call = "/emails/SearchEmails";
    }
    const res = await CallAPI(call, obj, "post", userToken);
    SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      setProcessing(false);
      let tempObj = [];

      for (const row of res.data.data) {
        row.CustomerId = customerCustVal;
        row.FlagType = "orgLIst";
        let cs = (
          <a
            href="javascript:void(0);"
            underline="none"
            className="font-weight-bold"
            onClick={() => {
              emailType(row, "show");
            }}
          >
            {row.directEmailAddress}
          </a>
        );

        row.dtCreated = new Date(row.dateCreated);
        row.GridLinkCourse = cs;
        row.date = new Date(row.dateCreated);
        row.keepMdn = row.isKeepMDN ? "YES" : "NO";
        row.directEmailPurpose =
          row.directEmailPurposeId === 0
            ? "General"
            : row.directEmailPurposeId === 1
            ? "Medical RecordsXML only"
            : row.directEmailPurposeId === 2
            ? "Medical Records"
            : "Administrative";
        let es = (
          <a
            href="javascript:void(0);"
            underline="none"
            className="font-weight-bold"
            onClick={() => {
              emailTypeName(row, "show");
            }}
          >
            {row.name}
          </a>
        );
        row.userEmailTypeString = row.emailType;
        row.EmailDirect = es;
        tempObj.push(row);
      }

      if (tempObj.length > 0) {
        $("#advEmailSearchModal").modal("hide");
        SetShowGridFlag(true);
      }
      SetSharedObject("emailListObj", tempObj);
    } else if (res.status === "SERVERERROR") {
      SetErrDetailsMsg("An error occurred. Please contact your administrator");
      SetErrDetailFlag(true);
    }
  };

  const getOrgDetails = async (id) => {
    SetSharedObject("orgXDRObj", {});
    SetSharedObject("orgDetails", {});
    setProcessing(true);

    let call = "/emails/GetOrgDetails?OrganizationId=" + parseInt(id);
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      GetXdrConfig(res.data.data.xdrConfig.id);
      SetSharedObject("orgDetails", res.data.data);
      SetSharedObject("orgActionObj", res.data.data);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";

      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }

    setProcessing(false);
  };

  const emailType = async (row) => {
    setSelectedProducts([row]);
    setProcessing(true);
    SetErrDetailFlag(false);
    setdetailsEmail({
      ...row,
      orgXDR: sharedObject.orgXDRObj,
      orgDetails: sharedObject.orgDetails,
    });

    if (row.emailType === "User" || row.emailType === "userEmails") {
      let call =
        "/emails/GetUserDirectEmails?directEmailId=" +
        parseInt(row.directEmailId) +
        "&UserId=" +
        row.userId;

      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        SetSharedObject("emailsForwarding", res.data.data.emailForwards);
        await setdetailsEmail({
          ...row,
          emailForwording: res.data.data.emailForwards,
        });
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        for (let el of msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrDetailsMsg(str);
        SetErrDetailFlag(true);
      }
    } else {
      let call =
        "/emails/GetUserSharedEmails?DirectEmail=" + row.directEmailAddress;

      const res = await CallAPI(call, false, "get", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        SetSharedObject("emailsSharing", res.data.data);
        setdetailsEmail({
          ...row,
          emailSharing: res.data.data,
        });
      } else if (res.status === "SERVERERROR") {
        SetErrDetailsMsg(
          "An error occurred. Please contact your administrator"
        );
        SetErrDetailFlag(true);
      }
    }

    setProcessing(false);
    $("#detailsEmailOrgModal").modal("show");
  };

  const emailTypeName = async (row) => {
    if (row.emailType === "Organization") {
      navigate("/organizations");
    } else {
      setProcessing(false);
      navigate("/users");
    }
  };

  const CustomerIdSet = async (el) => {
    setCustomerCustVal(el);

    if (el === "") {
      SetOrgObj([]);
      return;
    }

    customerObjSearch.map((elx) => {
      if (elx.id === parseInt(el))
        SetSharedObject("CustomerPermissionsObj", elx);
    });

    setAddBtnFlag(false);
    SetShowGridFlag(false);
    setProcessing(true);

    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      SetOrgObj(res.data.data);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }

    setProcessing(false);
  };

  const CustomerIdSetSearch = async (el) => {
    setCustomerCustValSearch(el);

    if (el === "") {
      SetOrgObjSearch([]);
      return;
    }

    customerObjSearch.map((elx) => {
      if (elx.id === parseInt(el))
        SetSharedObject("CustomerPermissionsObj", elx);
    });

    setProcessing(true);

    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);

    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObjSearch(temp);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };

  const SelectUsersByOrgId = async (vl) => {
    SetSharedObject("orgDetails", {});
    SetSharedObject("UserIdEmail", {});
    setCustomerOrgVal(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setOrgId(orgId);
    SetShowGridFlag(true);
    let src = {};
    src.OrganizationId = parseInt(orgId);
    getEmailsList(src, true);
  };

  const [orgIdSearch, setOrgIdSearch] = useState(false);

  const SelectUsersByOrgIdSearch = async (vl) => {
    SetCustFlag(false);
    SetShowBackBtn(false);
    setCustomerOrgValSearch(vl);
    let val = vl.split(",");
    let orgId = val[0];
    setOrgIdSearch(orgId);
    setAnswer("OrganizationId", orgId);
  };

  const SearchWithEnter = (e) => {
    if (e.key === "Enter") {
      SearchByEmail();
    }
  };

  const SearchByEmail = async () => {
    SetCustFlag(false);
    SetShowBackBtn(false);
    if (searchEmail === "") {
      return;
    }
    let src = {};
    //src.OrganizationId = orgId;
    src.Email = searchEmail;
    getEmailsList(src, false);
  };

  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      customerObjSearch?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      customerObjSearch?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustomerObjSearch(tmp);
  };

  const filterOrgs = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObjSearch?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObjSearch?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObjSearch(tmp);
  };

  const AdvSearch = () => {
    setSubmitFlag(true);
    SetCustFlag(false);
    SetShowBackBtn(false);
    if (answers.OrganizationId === "") return;
    SetShowGridFlag(true);
    answers.FromDate = $("#FromDate").datepicker("getFormattedDate");
    answers.ToDate = $("#EndDate").datepicker("getFormattedDate");
    getEmailsList(answers, true);
  };

  const showParent = (flag) => {
    if (flag) {
      if (sharedObject.UserIdEmail.Navigate === "orgEmails") {
        navigate("/organizations");
      } else if (sharedObject.UserIdEmail.Navigate === "Users") {
        navigate("/users");
      }
    }
  };

  const emailRefresh = (detailsEmail) => {
    let src = {};
    src.OrganizationId = parseInt(detailsEmail.organizationId, false);
    if (detailsEmail.FlagType === "orgLIst") {
      getEmailsList(src, true);
    } else {
      getOrgIdEmailsList(detailsEmail, true);
    }
  };

  const DeleteEmailComfirm = async () => {
    SetCmfFlag(0);
    SetCmfFlagDisplay(false);
    setDeleteFlag(false);
    if (selectedProducts.length === 0) {
      SetCmfMessage("Please select an email.");
      SetCmfFlag(1);
      return;
    } else {
      if (reasonInput === "") {
        setSbmitFlag(true);
        return;
      }
      await DeleteEmails();
      if (cmfFlag > 0) SetCmfFlagDisplay(true); //cmfFlagDisplay
    }
  };

  const DeleteEmails = async () => {
    SetCmfMessage("");
    setprocessingDelete(true);
    setDeleteFlag(false);

    for (const el of selectedProducts) {
      let orgId = el.organizationId ? el.organizationId : 0;
      let call =
        "/emails/DeleteUserDirectEmail?emailType=" +
        el.userEmailTypeString +
        "&directEmailId=" +
        el.directEmailId +
        "&userId=" +
        el.userId +
        "&directEmailAddress=" +
        el.directEmailAddress +
        "&orgId=" +
        orgId +
        "&reason=" +
        reasonInput;

      const res = await CallAPI(call, false, "post", userToken);
      SetSharedObject("ResponseCode", res.code);

      if (res.status === "SUCCESS") {
        if (res.data.data?.errorList?.messages?.length > 0) {
          let msg = res.data.data.errorList?.messages;
          let str = "<div>";
          for (let el of msg) {
            str += `${el}`;
          }
          str += "</div>";
          SetCmfMessage(str);
          SetCmfFlag(1);
        } else {
          /*   $("#comfirmDelete").modal("hide");*/
          setSelectedProducts([]);
          setDeleteFlag(true);
        }
      } else if (res.status === "SERVERERROR") {
        let msg = res.data;
        let str = "<div>";
        if (msg === "") {
          str += `System Error. Please contact your Administrator.`;
        } else {
          for (let el of msg) {
            str += `${el}`;
          }
        }
        str += "</div>";
        SetCmfMessage(str);
        SetCmfFlag(1);
      }
    }

    if (cmfFlag !== 1) {
      if (custFlag) {
        let obj = sharedObject.UserIdEmail;
        getOrgIdEmailsList(obj, true, true);
      } else {
        let src = {};
        src.OrganizationId = parseInt(orgId);
        getEmailsList(src, false);
      }
    }

    setprocessingDelete(false);
  };

  const createdDate = (dt) => {
    return dt.dateCreated ? new Date(dt.dateCreated).toLocaleString() : null;
  };

  function isEmpty(val) {
    return val === undefined || val == null || val.length <= 0 ? true : false;
  }

  const CloseDeleteModal = () => {
    setDeleteFlag(false);
    $("#comfirmDelete").modal("hide");
  };

  return (
    <div className="ListEmails">
      <div className="HeaderEmailTools">
        <header className="ht-6">
          <div className="spacer-inline sp-margin12">
            {showBackBtn ||
            (custFlag &&
              sharedObject.UserIdEmail.Navigate &&
              sharedObject.UserIdEmail.Navigate !== "detailUser") ? (
              <div className="spacer-inline btnback-container-1">
                <a
                  href="javascript:void(0);"
                  onClick={(el) => showParent(custFlag)}
                >
                  <i className="bi bi-arrow-left-square-fill"></i>
                </a>
              </div>
            ) : null}
            <div className="title-label4">
              {sharedObject.UserIdEmail?.Navigate === "orgEmails"
                ? `Emails for Org: ${sharedObject.UserIdEmail.Name}`
                : sharedObject.UserIdEmail?.Navigate === "detailUser"
                ? `Emails for User: ${sharedObject.UserIdEmail.Name}`
                : "List"}
            </div>
          </div>

          <div className="mid-header-bar">
            <div className="OrgDropdown spacer-inline">
              <aside>
                {addBtnFlag && sharedObject.UserIdEmail.Name ? (
                  <button
                    className="btn btn-primary spacer-margin5"
                    onClick={(el) => {
                      let o = {
                        id: sharedObject.UserIdEmail.Id,
                        name: sharedObject.UserIdEmail.Name,
                        domainName: sharedObject.UserIdEmail.Domain,
                        accountName: sharedObject.UserIdEmail.UserName,
                        firstName: sharedObject.UserIdEmail.FirstName,
                        userName: sharedObject.UserIdEmail.UserName,
                        lastName: sharedObject.UserIdEmail.LastName,
                        Flag: sharedObject.UserIdEmail.Flag,
                      };
                      if (sharedObject.UserIdEmail?.Flag === "orgEmails") {
                        SetSharedObject("orgActionObj", o);
                        $("#AddOrgEmailModal").modal("show");
                      } else if (
                        sharedObject.UserIdEmail?.Flag === "detailUser"
                      ) {
                        setEmailListObj(o);
                        $("#UsrEmailList").modal("show");
                      }
                    }}
                    data-toggle="modal"
                  >
                    Add
                  </button>
                ) : null}
                {userRole !== "SES ADMINISTRATOR" ? null : (
                  <Dropdown
                      value={selectedCustomer}
                      onChange={(e) => {
                        setSelectedCustomer(e.value);
                        CustomerIdSet(e.value?.id);
                      }}
                      options={customerObj}
                      optionLabel="name"
                      placeholder="Customers"
                      filter
                      className="form-control w-md2 spacer-margin5"
                    />
                )}

                <Dropdown
                    value={customerOrgVal}
                    onChange={(e) => {
                        const selectedValue = e.value;
                        if (selectedValue) {
                            SelectUsersByOrgId(selectedValue); // or use id only, if needed
                        }
                    }}
                    options={orgObj.map((el) => ({
                        label: el.name,
                        value: `${el.id},${el.name}`
                    }))}
                    placeholder="Organizations"
                    filter
                    className="form-control w-md2 spacer-margin5"
                />
              </aside>
            </div>

            {/*Search by name*/}
            <div className="spacer-inline spacer-margin5">
              <div className="input-group">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search by Email"
                  aria-label="Enter Name"
                  aria-describedby="Search by Name"
                  onChange={(el) => setSearchEmail(el.target.value)}
                  value={searchEmail}
                  onKeyPress={SearchWithEnter}
                />
                <div className="input-group-append">
                  <button
                    className="input-group-text btn btn-secondary"
                    id="basic-addon2"
                    onClick={(e) => SearchByEmail()}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                </div>
              </div>
            </div>

            {/* Advanced Search*/}
            <div className="spacer-inline">
              <button
                className="btn btn-primary"
                data-target="#advEmailSearchModal"
                data-toggle="modal"
              >
                Adv Search
              </button>
            </div>
          </div>
        </header>
      </div>
      <section className="sp-margin1">
        {errDetailFlag ? (
          <div
            className={`alert alert-danger`}
            dangerouslySetInnerHTML={{ __html: errDetailMsg }}
          />
        ) : null}
      </section>
      {showGridFlag ? (
        <section className="grid-layout">
          <div>
            <DataTable
              value={sharedObject.emailListObj}
              paginator
              selectionPageOnly
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              tableStyle={{ minWidth: "50rem" }}
              dataKey="id"
              paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              columnResizeMode="expand"
              resizableColumns
              selectionMode={"checkbox"}
              selection={selectedProducts}
              onSelectionChange={(e) => {
                setSelectedProducts(e.value);
              }}
              selectionAutoFocus={false}
              sortField="dtCreated"
              sortOrder={-1}
            >
              <Column selectionMode="multiple" className="w-s"></Column>
              <Column
                field="GridLinkCourse"
                header="Direct Email"
                className="truncate"
                sortable
              ></Column>
              {sharedObject.UserIdEmail?.Flag === "orgEmails" ||
              sharedObject.UserIdEmail?.Flag === "detailUser" ? null : (
                <Column
                  field="emailType"
                  header="Type"
                  className="w-md1"
                  sortable
                ></Column>
              )}
              <Column
                field="dtCreated"
                header="Date Created"
                className="w-md8"
                body={createdDate}
                sortable
              ></Column>
              <Column field="name" header="Name" sortable></Column>
              <Column
                field="directEmailPurpose"
                header="Purpose"
                className="w-md7"
                sortable
              ></Column>
              <Column
                field="keepMdn"
                header="Keep MDN"
                className="w-md1"
                sortable
              ></Column>
            </DataTable>
          </div>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <button
                className="btn btn-outline-secondary"
                onClick={(e) => {
                  SetCmfFlag(0);
                  setReasonInput("");
                  $("#comfirmDelete").modal("show");
                }}
              >
                Delete
              </button>
            </div>
          </div>
          {processing ? <div className="loading"></div> : null}
        </section>
      ) : (
        <section className="empty-grid">
          There are currently no results.
        </section>
      )}

      <div
        className="modal fade"
        id="comfirmDelete"
        data-backdrop="static"
        data-keyboard="false"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="delete Modal Comfirm"
        aria-hidden="false"
      >
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">Delete Confirmation</div>
              <button
                type="button"
                className="close"
                aria-label="Close"
                //data-dismiss="modal"
                onClick={CloseDeleteModal}
              >
                <span aria-hidden="false">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {deleteFlag ? (
                <div>
                  <div className="bi-success-check">
                    <i
                      className="bi bi-check2-circle"
                      alt="Success Checkmark"
                    ></i>
                  </div>
                  <div className="message-wrapper">Deleted Successfully!</div>
                </div>
              ) : (
                //<p className={`alert alert-success`}>
                //  <ul className="sp-margin4">
                //    {selectedProducts.map((el) => (
                //      <li key={el.id}>{el.directEmailAddress}</li>
                //    ))}
                //  </ul>{" "}
                //  Successfully deleted.
                //</p>
                <>
                  {selectedProducts.length === 0 ? (
                    <div class="ctr sp-pad3">
                      There was nothing selected to delete.
                    </div>
                  ) : (
                    <>
                      <div className="field-wrapper">
                        <div className="descript2-container">
                          Mailbox will be permenantly deleted from your account.
                        </div>
                        <div className="spacer-margin7 line-s1">
                          <label>Are you sure you want to delete?</label>
                        </div>
                        <ul className="sp-margin4">
                          {selectedProducts.map((el) => (
                            <li key={el.id}>{el.directEmailAddress}</li>
                          ))}
                        </ul>
                      </div>
                      <div className="modal-content-body sp-margin14">
                        <label>Reason</label>
                        <input
                          className="form-control"
                          value={reasonInput}
                          onChange={(e) => setReasonInput(e.target.value)}
                        />
                        <div className="sp-margin3">
                          Please provide a reason why you are deleting the
                          mailbox.
                        </div>
                        {sbmitFlag && reasonInput === "" ? (
                          <div className="alert alert-danger field-wrapper">
                            Reason field is required.
                          </div>
                        ) : null}
                      </div>
                    </>
                  )}
                  {cmfFlag === 1 ? (
                    <p
                      className={`alert alert-danger`}
                      dangerouslySetInnerHTML={{
                        __html: cmfMessage,
                      }}
                    />
                  ) : null}
                </>
              )}
            </div>
            <div className="modal-footer">
              {processingDelete ? <div className="loading"></div> : null}
              {selectedProducts.length === 0 || deleteFlag ? null : (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => DeleteEmailComfirm()}
                >
                  Confirm
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseDeleteModal}
                //data-dismiss="modal"
              >
                {selectedProducts.length === 0 || deleteFlag
                  ? "Close"
                  : "Cancel"}
              </button>
            </div>
          </div>
          {/* {processingDelete ? <div className="loading"></div> : null}*/}
        </div>
      </div>
      <div className="SearchEmails">
        <div
          className="modal fade"
          id="advEmailSearchModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="AdvancedEmailSearch"
          aria-hidden="false"
        >
          <div className="modal-dialog modal-dialog-slideout">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title spacer-inline" id="myModalLabel">
                  {" "}
                  Advanced Search{" "}
                </div>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  data-dismiss="modal"
                >
                  {" "}
                  <span aria-hidden="false">&times;</span>{" "}
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="modal-content-body container">
                    {/*Customers SES Admins only*/}
                    {userRole !== "SES ADMINISTRATOR" ? null : (
                      <div className="field-wrapper">
                        <label for="customer" className="sp-margin3">
                          Customer
                        </label>
                        <span className="filter-container dg-clr">
                          <input
                            className="form-control filter-sm"
                            type="search"
                            placeholder="Filter"
                            onChange={(el) => {
                              filterVendors(el.target.value);
                            }}
                          />
                        </span>
                        <select
                          className="form-control"
                          size="4"
                          onChange={(el) => {
                            CustomerIdSetSearch(el.target.value);
                          }}
                          value={customerCustValSearch}
                        >
                          <option value="">Select Customer</option>
                          {customerObjSearch?.map((el) => {
                            if (el.show)
                              return (
                                <option key={el.id} value={el.id}>
                                  {el.name}
                                </option>
                              );
                          })}
                        </select>
                      </div>
                    )}
                    {/*Organizations*/}
                    <div className="field-wrapper">
                      <label for="Org" className="sp-margin3">
                        Organization
                      </label>
                      {/*<i className="bi bi-asterisk rd-clr"></i>*/}
                      <span className="filter-container dg-clr">
                        <input
                          className="form-control filter-sm"
                          type="search"
                          placeholder="Filter"
                          onChange={(el) => filterOrgs(el.target.value)}
                        />
                      </span>
                      {orgObjSearch.length === 0 ? (
                        <div className="watermark-wrapper">No Results</div>
                      ) : (
                        <select
                          className="form-control"
                          size="4"
                          onChange={(el) => {
                            if (el.target.value !== "") {
                              SelectUsersByOrgIdSearch(el.target.value);
                            }
                          }}
                          value={customerOrgValSearch}
                        >
                          <option value="">Select Organization</option>
                          {orgObjSearch.map((el) => {
                            if (el.show)
                              return (
                                <option key={el.id} value={el.id}>
                                  {el.name}
                                </option>
                              );
                          })}
                        </select>
                      )}
                      {!customerOrgValSearch && submitFlag ? (
                        <div className="alert alert-danger">
                          Organization is Required!
                        </div>
                      ) : null}
                    </div>

                    {/*Email*/}
                    <div className="field-wrapper">
                      <label for="email">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(el) => setAnswer("Email", el.target.value)}
                        value={answers?.Email}
                        placeholder="Enter Direct Email"
                      />
                    </div>
                    <div className="field-wrapper">
                      {/* From Date*/}
                      <div className="spacer-margin5 spacer-inline w-md2">
                        <label for="FromDate">From Date</label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          // data-date-start-date="-7d"
                          data-date-end-date="0d"
                          onChange={(el) =>
                            setAnswer("FromDate", el.target.value)
                          }
                          value={answers?.FromDate}
                          data-date={answers?.FromDate}
                          id="FromDate"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="StartDate"
                          />
                          <div className="input-group-append">
                            <span className="input-group-text" id="">
                              <i className="fas fa-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* To Date*/}
                      <div className="spacer-inline w-md2">
                        <label for="ToDate">To Date</label>
                        <div
                          className="input-group date"
                          data-provide="datepicker"
                          // data-date-start-date="-7d"
                          data-date-end-date="0d"
                          id="EndDate"
                        >
                          <input
                            type="text"
                            className="form-control"
                            name="EndDate"
                            onChange={(el) => {
                              setAnswer("ToDate", el.target.value);
                            }}
                            value={answers?.ToDate}
                          />
                          <div className="input-group-append">
                            <span className="input-group-text" id="">
                              <i className="fas fa-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="sp-margin13">
                        Set a date range to specify results within that time
                        period.
                      </div>
                    </div>

                    {/*First or Last Name*/}
                    <div className="field-wrapper">
                      <label for="name">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={(el) => setAnswer("Name", el.target.value)}
                        value={answers?.Name}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={(e) => AdvSearch()}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    data-dismiss="modal"
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                </div>
              </form>
            </div>
          </div>
          {processing ? <div className="loading"></div> : null}
        </div>
      </div>
      <UserEmailList emailListObj={emailListObj} />
      <DetailsOrgEmails
        detailsEmail={detailsEmail}
        emailRefresh={emailRefresh}
      />
    </div>
  );
};

export default ListEmails;
